import { Container, Grid } from '@material-ui/core'
import { useEffect, useState, useRef } from 'react'
import { ButtonHLPure, TooltipHLPure } from '../../pures'
import LabelPure from '../../pures/label/label.pure'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import TextareaWrapper from '../onboarding/steps/inputs/textareaWrapper'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { useTranslation } from 'react-i18next'
import TextAreaWrapper from '../onboarding/steps/inputs/textareaWrapper'
import './chatbot-configuration.css'

const ChatbotInstructionsView = (props) => {
  const {
    initialData,
    saveData,
    assistantTones,
    assistantTonesRaw
  } = props

  const { t } = useTranslation('chatbot', { keyPrefix: 'configuration' })
  const { t: tCommon } = useTranslation('common')
  const [dropdownSelected, setDropdownSelected] = useState(t(`instructions.assistantTone.comboboxTypes.${initialData?.assistantTone}`))

  const [formKey, setFormKey] = useState(1)

  const resetForm = () => setFormKey(formKey + 1)

  useEffect(() => {
    resetForm()
  }, [initialData])

  return (
    <Container maxWidth={'md'}>
      <Form
        key={`chatbot-configuration-${formKey}`}
        initialValues={initialData}
        onSubmit={saveData}
        render={(formRenderProps) => {
          return (
            <FormElement>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    id='initialMessage'
                    name={'initialMessage'}
                    component={TextAreaWrapper}
                    label={t('instructions.initialMessage')}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <LabelPure title={t('instructions.additionalInstructions')} editorId='additionalInstructions' />
                    <TooltipHLPure
                      positionTooltip={'right'}
                      descriptionTooltip={t('instructions.tooltipInstructions')}
                      informationIcon
                    />
                  </div>
                  <Field
                    id='additionalInstructions'
                    name={'additionalInstructions'}
                    component={TextareaWrapper}
                    maxLength={10000}
                    rows={4}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelPure title={t('instructions.assistantTone.title')} editorId='assistantTone' />
                  <Field
                    id='assistantTone'
                    name={'assistantTone'}
                    component={({ onChange: onChangeProps }) => {
                      return (
                        <DropDownList
                          id='assistantTone'
                          name={'assistantTone'}
                          className='eticket-dropdown-field'
                          data={assistantTones}
                          defaultValue={dropdownSelected}
                          onChange={(e) => {
                            const auxTone = assistantTonesRaw.find((assistantTone) => e.target.value === t(`instructions.assistantTone.comboboxTypes.${assistantTone.name}`))
                            setDropdownSelected(t(`instructions.assistantTone.comboboxTypes.${auxTone.name}`))
                            onChangeProps({ target: { value: e.target.value } })
                          }}
                        />
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} className='button-actions'>
                  {
                    formRenderProps.modified &&
                    <ButtonHLPure colorScheme='error' outlined nameBtn={tCommon('cancel')} onClick={() => {
                      resetForm()
                    }} />
                  }
                  <ButtonHLPure primary nameBtn={tCommon('save')} type='submit' />
                </Grid>
              </Grid>
            </FormElement>
          )
        }}
      />
    </Container>
  )
}

export default ChatbotInstructionsView